import type { ChalkAssetsPort } from 'ai-tutor-player';

import kalamBoldUrl from '@/assets/fonts/Kalam-Bold.ttf';
import kalamLightUrl from '@/assets/fonts/Kalam-Light.ttf';
import kalamUrl from '@/assets/fonts/Kalam-Regular.ttf';

/**
 * Admin host provider for the shared player's canonical handwriting. The admin
 * bundles all three Kalam weights (the board font); the pencil is drawn in SVG
 * by the player, so no pencil image is needed. Register once (e.g. before
 * mounting <SlidePlayer>) so the LMS Preview matches the Teach page's
 * handwriting. Weight buckets: ≤350 → Light, ≥600 → Bold, else Regular — the
 * same faces globals.css declares, so plain CSS text and glyph handwriting
 * always agree on the letterforms.
 */
export const adminChalkAssets: ChalkAssetsPort = {
  fontUrl: (_family, weight) => {
    const w = weight ?? 400;
    if (w <= 350) return kalamLightUrl;
    if (w >= 600) return kalamBoldUrl;
    return kalamUrl;
  },
};
